import { useState, useRef, useEffect } from 'react';
import { Direction } from './constants.js';

const useScroll = () => {
    const { UP, DOWN } = Direction;
    const [scrollPosition, setScrollPosition] = useState(0);
    const [scrollDirection, setScrollDirection] = useState(UP);
    const prevPosition = useRef(0);
    const blocking = useRef(false);
    useEffect(() => {
        prevPosition.current = window.scrollY;
        const handleScroll = () => {
            const currentPosition = window.scrollY;
            if (Math.abs(currentPosition - prevPosition.current) >= 0) {
                const newScrollDirection = currentPosition > prevPosition.current ? DOWN : UP;
                setScrollDirection(newScrollDirection);
                prevPosition.current = currentPosition > 0 ? currentPosition : 0;
            }
            setScrollPosition(currentPosition);
            blocking.current = false;
        };
        const onScroll = () => {
            if (!blocking.current) {
                blocking.current = true;
                window.requestAnimationFrame(handleScroll);
            }
        };
        window.addEventListener("scroll", onScroll);
        handleScroll();
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, [DOWN, UP]);
    return { scrollPosition, scrollDirection };
};

export { useScroll as default };
//# sourceMappingURL=index.js.map
